import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import MuiRadioGroup from '@mui/material/RadioGroup';
import { type ChangeEvent } from 'react';
import { Radio } from './Radio';

export type RadioOption = {
  value: string;
  label: string;
  disabled?: boolean;
};

export type RadioGroupProps = {
  label?: string;
  helperText?: string;
  error?: boolean;
  required?: boolean;
  options: RadioOption[];
  value?: string;
  defaultValue?: string;
  onChange?: (value: string, event: ChangeEvent<HTMLInputElement>) => void;
  row?: boolean;
  name?: string;
  size?: 'small' | 'medium';
};

/** RadioGroup that renders options array with labels/values. */
export const RadioGroup = ({
  label,
  helperText,
  error,
  required,
  options,
  value,
  defaultValue,
  onChange,
  row,
  name,
  size = 'medium'
}: RadioGroupProps) => {
  return (
    <FormControl error={error}>
      {label ? <FormLabel required={required}>{label}</FormLabel> : null}
      <MuiRadioGroup
        name={name}
        row={row}
        value={value}
        defaultValue={defaultValue}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value, e)}
      >
        {options.map(o => (
          <Radio key={o.value} value={o.value} label={o.label} disabled={o.disabled} size={size} />
        ))}
      </MuiRadioGroup>
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
};
